const config = {
  ssoUrl: 'https://staging.gorillasafety.com/auth/login', // Gorilla Safety Staging
};

export default config;